import { render, staticRenderFns } from "./CapturedImgsList.vue?vue&type=template&id=876210c6&scoped=true&"
import script from "./CapturedImgsList.vue?vue&type=script&lang=js&"
export * from "./CapturedImgsList.vue?vue&type=script&lang=js&"
import style0 from "./CapturedImgsList.vue?vue&type=style&index=0&id=876210c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876210c6",
  null
  
)

export default component.exports